/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DPL CMS - REST API
 * The REST API provided by the core REST module.
 * OpenAPI spec version: Versioning not supported
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from "@tanstack/react-query";

import type {
  CampaignMatchPOST200,
  CampaignMatchPOSTBody,
  CampaignMatchPOSTParams,
  CurrentEventsGET200Item,
  CurrentEventsGETParams,
  DplOpeningHoursCreatePOST200Item,
  DplOpeningHoursCreatePOSTBody,
  DplOpeningHoursCreatePOSTParams,
  DplOpeningHoursDeleteDELETEParams,
  DplOpeningHoursLegacyListGET200Item,
  DplOpeningHoursLegacyListGETParams,
  DplOpeningHoursListGET200Item,
  DplOpeningHoursListGETParams,
  DplOpeningHoursUpdatePATCH200Item,
  DplOpeningHoursUpdatePATCHBody,
  DplOpeningHoursUpdatePATCHParams,
  EventPATCHBody,
  EventPATCHParams,
  EventsGET200Item,
  EventsGETParams,
  ProxyUrlGET200,
  ProxyUrlGETParams
} from "./model";

import { mutator } from "./mutator/mutator";
import type { ErrorType, BodyType } from "./mutator/mutator";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const getCampaignMatchPOSTUrl = (params: CampaignMatchPOSTParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/dpl_campaign/match?${stringifiedParams}`
    : `/dpl_campaign/match`;
};

/**
 * @summary Get campaign matching search result facets
 */
export const campaignMatchPOST = async (
  campaignMatchPOSTBody: CampaignMatchPOSTBody,
  params: CampaignMatchPOSTParams,
  options?: Parameters<typeof mutator>[1]
): Promise<CampaignMatchPOST200> => {
  const getHeaders = (h?: HeadersInit | Headers): Record<string, string> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return mutator<CampaignMatchPOST200>(getCampaignMatchPOSTUrl(params), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(campaignMatchPOSTBody)
  });
};

export const getCampaignMatchPOSTMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof campaignMatchPOST>>,
    TError,
    { data: BodyType<CampaignMatchPOSTBody>; params: CampaignMatchPOSTParams },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof campaignMatchPOST>>,
  TError,
  { data: BodyType<CampaignMatchPOSTBody>; params: CampaignMatchPOSTParams },
  TContext
> => {
  const mutationKey = ["campaignMatchPOST"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof campaignMatchPOST>>,
    { data: BodyType<CampaignMatchPOSTBody>; params: CampaignMatchPOSTParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return campaignMatchPOST(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CampaignMatchPOSTMutationResult = NonNullable<
  Awaited<ReturnType<typeof campaignMatchPOST>>
>;
export type CampaignMatchPOSTMutationBody = BodyType<CampaignMatchPOSTBody>;
export type CampaignMatchPOSTMutationError = ErrorType<void>;

/**
 * @summary Get campaign matching search result facets
 */
export const useCampaignMatchPOST = <
  TError = ErrorType<void>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof campaignMatchPOST>>,
      TError,
      {
        data: BodyType<CampaignMatchPOSTBody>;
        params: CampaignMatchPOSTParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof campaignMatchPOST>>,
  TError,
  { data: BodyType<CampaignMatchPOSTBody>; params: CampaignMatchPOSTParams },
  TContext
> => {
  return useMutation(getCampaignMatchPOSTMutationOptions(options), queryClient);
};

export const getCurrentEventsGETUrl = (params: CurrentEventsGETParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/events/current?${stringifiedParams}`
    : `/api/v1/events/current`;
};

/**
 * @summary Retrieve current events
 */
export const currentEventsGET = async (
  params: CurrentEventsGETParams,
  options?: Parameters<typeof mutator>[1]
): Promise<CurrentEventsGET200Item[]> => {
  return mutator<CurrentEventsGET200Item[]>(getCurrentEventsGETUrl(params), {
    ...options,
    method: "GET"
  });
};

export const getCurrentEventsGETQueryKey = (
  params?: CurrentEventsGETParams
) => {
  return [`/api/v1/events/current`, ...(params ? [params] : [])] as const;
};

export const getCurrentEventsGETQueryOptions = <
  TData = Awaited<ReturnType<typeof currentEventsGET>>,
  TError = ErrorType<void>
>(
  params: CurrentEventsGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentEventsGET>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCurrentEventsGETQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof currentEventsGET>>
  > = ({ signal }) => currentEventsGET(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof currentEventsGET>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CurrentEventsGETQueryResult = NonNullable<
  Awaited<ReturnType<typeof currentEventsGET>>
>;
export type CurrentEventsGETQueryError = ErrorType<void>;

export function useCurrentEventsGET<
  TData = Awaited<ReturnType<typeof currentEventsGET>>,
  TError = ErrorType<void>
>(
  params: CurrentEventsGETParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentEventsGET>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentEventsGET>>,
          TError,
          Awaited<ReturnType<typeof currentEventsGET>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentEventsGET<
  TData = Awaited<ReturnType<typeof currentEventsGET>>,
  TError = ErrorType<void>
>(
  params: CurrentEventsGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentEventsGET>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentEventsGET>>,
          TError,
          Awaited<ReturnType<typeof currentEventsGET>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentEventsGET<
  TData = Awaited<ReturnType<typeof currentEventsGET>>,
  TError = ErrorType<void>
>(
  params: CurrentEventsGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentEventsGET>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve current events
 */

export function useCurrentEventsGET<
  TData = Awaited<ReturnType<typeof currentEventsGET>>,
  TError = ErrorType<void>
>(
  params: CurrentEventsGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentEventsGET>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCurrentEventsGETQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDplOpeningHoursCreatePOSTUrl = (
  params: DplOpeningHoursCreatePOSTParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/opening_hours?${stringifiedParams}`
    : `/api/v1/opening_hours`;
};

/**
 * @summary Create individual opening hours
 */
export const dplOpeningHoursCreatePOST = async (
  dplOpeningHoursCreatePOSTBody: DplOpeningHoursCreatePOSTBody,
  params: DplOpeningHoursCreatePOSTParams,
  options?: Parameters<typeof mutator>[1]
): Promise<DplOpeningHoursCreatePOST200Item[]> => {
  const getHeaders = (h?: HeadersInit | Headers): Record<string, string> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return mutator<DplOpeningHoursCreatePOST200Item[]>(
    getDplOpeningHoursCreatePOSTUrl(params),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers)
      },
      body: JSON.stringify(dplOpeningHoursCreatePOSTBody)
    }
  );
};

export const getDplOpeningHoursCreatePOSTMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dplOpeningHoursCreatePOST>>,
    TError,
    {
      data: BodyType<DplOpeningHoursCreatePOSTBody>;
      params: DplOpeningHoursCreatePOSTParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dplOpeningHoursCreatePOST>>,
  TError,
  {
    data: BodyType<DplOpeningHoursCreatePOSTBody>;
    params: DplOpeningHoursCreatePOSTParams;
  },
  TContext
> => {
  const mutationKey = ["dplOpeningHoursCreatePOST"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dplOpeningHoursCreatePOST>>,
    {
      data: BodyType<DplOpeningHoursCreatePOSTBody>;
      params: DplOpeningHoursCreatePOSTParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return dplOpeningHoursCreatePOST(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DplOpeningHoursCreatePOSTMutationResult = NonNullable<
  Awaited<ReturnType<typeof dplOpeningHoursCreatePOST>>
>;
export type DplOpeningHoursCreatePOSTMutationBody =
  BodyType<DplOpeningHoursCreatePOSTBody>;
export type DplOpeningHoursCreatePOSTMutationError = ErrorType<void>;

/**
 * @summary Create individual opening hours
 */
export const useDplOpeningHoursCreatePOST = <
  TError = ErrorType<void>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof dplOpeningHoursCreatePOST>>,
      TError,
      {
        data: BodyType<DplOpeningHoursCreatePOSTBody>;
        params: DplOpeningHoursCreatePOSTParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof dplOpeningHoursCreatePOST>>,
  TError,
  {
    data: BodyType<DplOpeningHoursCreatePOSTBody>;
    params: DplOpeningHoursCreatePOSTParams;
  },
  TContext
> => {
  return useMutation(
    getDplOpeningHoursCreatePOSTMutationOptions(options),
    queryClient
  );
};

export const getDplOpeningHoursListGETUrl = (
  params: DplOpeningHoursListGETParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/opening_hours?${stringifiedParams}`
    : `/api/v1/opening_hours`;
};

/**
 * @summary List all opening hours
 */
export const dplOpeningHoursListGET = async (
  params: DplOpeningHoursListGETParams,
  options?: Parameters<typeof mutator>[1]
): Promise<DplOpeningHoursListGET200Item[]> => {
  return mutator<DplOpeningHoursListGET200Item[]>(
    getDplOpeningHoursListGETUrl(params),
    {
      ...options,
      method: "GET"
    }
  );
};

export const getDplOpeningHoursListGETQueryKey = (
  params?: DplOpeningHoursListGETParams
) => {
  return [`/api/v1/opening_hours`, ...(params ? [params] : [])] as const;
};

export const getDplOpeningHoursListGETQueryOptions = <
  TData = Awaited<ReturnType<typeof dplOpeningHoursListGET>>,
  TError = ErrorType<void>
>(
  params: DplOpeningHoursListGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dplOpeningHoursListGET>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDplOpeningHoursListGETQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dplOpeningHoursListGET>>
  > = ({ signal }) =>
    dplOpeningHoursListGET(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dplOpeningHoursListGET>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DplOpeningHoursListGETQueryResult = NonNullable<
  Awaited<ReturnType<typeof dplOpeningHoursListGET>>
>;
export type DplOpeningHoursListGETQueryError = ErrorType<void>;

export function useDplOpeningHoursListGET<
  TData = Awaited<ReturnType<typeof dplOpeningHoursListGET>>,
  TError = ErrorType<void>
>(
  params: DplOpeningHoursListGETParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dplOpeningHoursListGET>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dplOpeningHoursListGET>>,
          TError,
          Awaited<ReturnType<typeof dplOpeningHoursListGET>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDplOpeningHoursListGET<
  TData = Awaited<ReturnType<typeof dplOpeningHoursListGET>>,
  TError = ErrorType<void>
>(
  params: DplOpeningHoursListGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dplOpeningHoursListGET>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dplOpeningHoursListGET>>,
          TError,
          Awaited<ReturnType<typeof dplOpeningHoursListGET>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDplOpeningHoursListGET<
  TData = Awaited<ReturnType<typeof dplOpeningHoursListGET>>,
  TError = ErrorType<void>
>(
  params: DplOpeningHoursListGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dplOpeningHoursListGET>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all opening hours
 */

export function useDplOpeningHoursListGET<
  TData = Awaited<ReturnType<typeof dplOpeningHoursListGET>>,
  TError = ErrorType<void>
>(
  params: DplOpeningHoursListGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dplOpeningHoursListGET>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDplOpeningHoursListGETQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDplOpeningHoursDeleteDELETEUrl = (
  id: string,
  params: DplOpeningHoursDeleteDELETEParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/opening_hours/${id}?${stringifiedParams}`
    : `/api/v1/opening_hours/${id}`;
};

/**
 * @summary Delete individual opening hours
 */
export const dplOpeningHoursDeleteDELETE = async (
  id: string,
  params: DplOpeningHoursDeleteDELETEParams,
  options?: Parameters<typeof mutator>[1]
): Promise<void> => {
  return mutator<void>(getDplOpeningHoursDeleteDELETEUrl(id, params), {
    ...options,
    method: "DELETE"
  });
};

export const getDplOpeningHoursDeleteDELETEMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dplOpeningHoursDeleteDELETE>>,
    TError,
    { id: string; params: DplOpeningHoursDeleteDELETEParams },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dplOpeningHoursDeleteDELETE>>,
  TError,
  { id: string; params: DplOpeningHoursDeleteDELETEParams },
  TContext
> => {
  const mutationKey = ["dplOpeningHoursDeleteDELETE"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dplOpeningHoursDeleteDELETE>>,
    { id: string; params: DplOpeningHoursDeleteDELETEParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return dplOpeningHoursDeleteDELETE(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DplOpeningHoursDeleteDELETEMutationResult = NonNullable<
  Awaited<ReturnType<typeof dplOpeningHoursDeleteDELETE>>
>;

export type DplOpeningHoursDeleteDELETEMutationError = ErrorType<void>;

/**
 * @summary Delete individual opening hours
 */
export const useDplOpeningHoursDeleteDELETE = <
  TError = ErrorType<void>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof dplOpeningHoursDeleteDELETE>>,
      TError,
      { id: string; params: DplOpeningHoursDeleteDELETEParams },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof dplOpeningHoursDeleteDELETE>>,
  TError,
  { id: string; params: DplOpeningHoursDeleteDELETEParams },
  TContext
> => {
  return useMutation(
    getDplOpeningHoursDeleteDELETEMutationOptions(options),
    queryClient
  );
};

export const getDplOpeningHoursUpdatePATCHUrl = (
  id: string,
  params: DplOpeningHoursUpdatePATCHParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/opening_hours/${id}?${stringifiedParams}`
    : `/api/v1/opening_hours/${id}`;
};

/**
 * @summary Update individual opening hours
 */
export const dplOpeningHoursUpdatePATCH = async (
  id: string,
  dplOpeningHoursUpdatePATCHBody: DplOpeningHoursUpdatePATCHBody,
  params: DplOpeningHoursUpdatePATCHParams,
  options?: Parameters<typeof mutator>[1]
): Promise<DplOpeningHoursUpdatePATCH200Item[]> => {
  const getHeaders = (h?: HeadersInit | Headers): Record<string, string> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return mutator<DplOpeningHoursUpdatePATCH200Item[]>(
    getDplOpeningHoursUpdatePATCHUrl(id, params),
    {
      ...options,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers)
      },
      body: JSON.stringify(dplOpeningHoursUpdatePATCHBody)
    }
  );
};

export const getDplOpeningHoursUpdatePATCHMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dplOpeningHoursUpdatePATCH>>,
    TError,
    {
      id: string;
      data: BodyType<DplOpeningHoursUpdatePATCHBody>;
      params: DplOpeningHoursUpdatePATCHParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dplOpeningHoursUpdatePATCH>>,
  TError,
  {
    id: string;
    data: BodyType<DplOpeningHoursUpdatePATCHBody>;
    params: DplOpeningHoursUpdatePATCHParams;
  },
  TContext
> => {
  const mutationKey = ["dplOpeningHoursUpdatePATCH"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dplOpeningHoursUpdatePATCH>>,
    {
      id: string;
      data: BodyType<DplOpeningHoursUpdatePATCHBody>;
      params: DplOpeningHoursUpdatePATCHParams;
    }
  > = (props) => {
    const { id, data, params } = props ?? {};

    return dplOpeningHoursUpdatePATCH(id, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DplOpeningHoursUpdatePATCHMutationResult = NonNullable<
  Awaited<ReturnType<typeof dplOpeningHoursUpdatePATCH>>
>;
export type DplOpeningHoursUpdatePATCHMutationBody =
  BodyType<DplOpeningHoursUpdatePATCHBody>;
export type DplOpeningHoursUpdatePATCHMutationError = ErrorType<void>;

/**
 * @summary Update individual opening hours
 */
export const useDplOpeningHoursUpdatePATCH = <
  TError = ErrorType<void>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof dplOpeningHoursUpdatePATCH>>,
      TError,
      {
        id: string;
        data: BodyType<DplOpeningHoursUpdatePATCHBody>;
        params: DplOpeningHoursUpdatePATCHParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof dplOpeningHoursUpdatePATCH>>,
  TError,
  {
    id: string;
    data: BodyType<DplOpeningHoursUpdatePATCHBody>;
    params: DplOpeningHoursUpdatePATCHParams;
  },
  TContext
> => {
  return useMutation(
    getDplOpeningHoursUpdatePATCHMutationOptions(options),
    queryClient
  );
};

export const getDplOpeningHoursLegacyListGETUrl = (
  params: DplOpeningHoursLegacyListGETParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/opening_hours/instances?${stringifiedParams}`
    : `/opening_hours/instances`;
};

/**
 * @summary List all opening hours for legacy API
 */
export const dplOpeningHoursLegacyListGET = async (
  params: DplOpeningHoursLegacyListGETParams,
  options?: Parameters<typeof mutator>[1]
): Promise<DplOpeningHoursLegacyListGET200Item[]> => {
  return mutator<DplOpeningHoursLegacyListGET200Item[]>(
    getDplOpeningHoursLegacyListGETUrl(params),
    {
      ...options,
      method: "GET"
    }
  );
};

export const getDplOpeningHoursLegacyListGETQueryKey = (
  params?: DplOpeningHoursLegacyListGETParams
) => {
  return [`/opening_hours/instances`, ...(params ? [params] : [])] as const;
};

export const getDplOpeningHoursLegacyListGETQueryOptions = <
  TData = Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>,
  TError = ErrorType<void>
>(
  params: DplOpeningHoursLegacyListGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDplOpeningHoursLegacyListGETQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>
  > = ({ signal }) =>
    dplOpeningHoursLegacyListGET(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DplOpeningHoursLegacyListGETQueryResult = NonNullable<
  Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>
>;
export type DplOpeningHoursLegacyListGETQueryError = ErrorType<void>;

export function useDplOpeningHoursLegacyListGET<
  TData = Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>,
  TError = ErrorType<void>
>(
  params: DplOpeningHoursLegacyListGETParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>,
          TError,
          Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDplOpeningHoursLegacyListGET<
  TData = Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>,
  TError = ErrorType<void>
>(
  params: DplOpeningHoursLegacyListGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>,
          TError,
          Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDplOpeningHoursLegacyListGET<
  TData = Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>,
  TError = ErrorType<void>
>(
  params: DplOpeningHoursLegacyListGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all opening hours for legacy API
 */

export function useDplOpeningHoursLegacyListGET<
  TData = Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>,
  TError = ErrorType<void>
>(
  params: DplOpeningHoursLegacyListGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dplOpeningHoursLegacyListGET>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDplOpeningHoursLegacyListGETQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEventPATCHUrl = (uuid: string, params: EventPATCHParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/events/${uuid}?${stringifiedParams}`
    : `/api/v1/events/${uuid}`;
};

/**
 * @summary Update single events
 */
export const eventPATCH = async (
  uuid: string,
  eventPATCHBody: EventPATCHBody,
  params: EventPATCHParams,
  options?: Parameters<typeof mutator>[1]
): Promise<void> => {
  const getHeaders = (h?: HeadersInit | Headers): Record<string, string> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return mutator<void>(getEventPATCHUrl(uuid, params), {
    ...options,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(eventPATCHBody)
  });
};

export const getEventPATCHMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof eventPATCH>>,
    TError,
    { uuid: string; data: BodyType<EventPATCHBody>; params: EventPATCHParams },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof eventPATCH>>,
  TError,
  { uuid: string; data: BodyType<EventPATCHBody>; params: EventPATCHParams },
  TContext
> => {
  const mutationKey = ["eventPATCH"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof eventPATCH>>,
    { uuid: string; data: BodyType<EventPATCHBody>; params: EventPATCHParams }
  > = (props) => {
    const { uuid, data, params } = props ?? {};

    return eventPATCH(uuid, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EventPATCHMutationResult = NonNullable<
  Awaited<ReturnType<typeof eventPATCH>>
>;
export type EventPATCHMutationBody = BodyType<EventPATCHBody>;
export type EventPATCHMutationError = ErrorType<void>;

/**
 * @summary Update single events
 */
export const useEventPATCH = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof eventPATCH>>,
      TError,
      {
        uuid: string;
        data: BodyType<EventPATCHBody>;
        params: EventPATCHParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof eventPATCH>>,
  TError,
  { uuid: string; data: BodyType<EventPATCHBody>; params: EventPATCHParams },
  TContext
> => {
  return useMutation(getEventPATCHMutationOptions(options), queryClient);
};

export const getEventsGETUrl = (params: EventsGETParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/events?${stringifiedParams}`
    : `/api/v1/events`;
};

/**
 * @summary Retrieve all events
 */
export const eventsGET = async (
  params: EventsGETParams,
  options?: Parameters<typeof mutator>[1]
): Promise<EventsGET200Item[]> => {
  return mutator<EventsGET200Item[]>(getEventsGETUrl(params), {
    ...options,
    method: "GET"
  });
};

export const getEventsGETQueryKey = (params?: EventsGETParams) => {
  return [`/api/v1/events`, ...(params ? [params] : [])] as const;
};

export const getEventsGETQueryOptions = <
  TData = Awaited<ReturnType<typeof eventsGET>>,
  TError = ErrorType<void>
>(
  params: EventsGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof eventsGET>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEventsGETQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof eventsGET>>> = ({
    signal
  }) => eventsGET(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof eventsGET>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EventsGETQueryResult = NonNullable<
  Awaited<ReturnType<typeof eventsGET>>
>;
export type EventsGETQueryError = ErrorType<void>;

export function useEventsGET<
  TData = Awaited<ReturnType<typeof eventsGET>>,
  TError = ErrorType<void>
>(
  params: EventsGETParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof eventsGET>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsGET>>,
          TError,
          Awaited<ReturnType<typeof eventsGET>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useEventsGET<
  TData = Awaited<ReturnType<typeof eventsGET>>,
  TError = ErrorType<void>
>(
  params: EventsGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof eventsGET>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsGET>>,
          TError,
          Awaited<ReturnType<typeof eventsGET>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useEventsGET<
  TData = Awaited<ReturnType<typeof eventsGET>>,
  TError = ErrorType<void>
>(
  params: EventsGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof eventsGET>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve all events
 */

export function useEventsGET<
  TData = Awaited<ReturnType<typeof eventsGET>>,
  TError = ErrorType<void>
>(
  params: EventsGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof eventsGET>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getEventsGETQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getProxyUrlGETUrl = (params: ProxyUrlGETParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/dpl-url-proxy?${stringifiedParams}`
    : `/dpl-url-proxy`;
};

/**
 * @summary Generate proxy url
 */
export const proxyUrlGET = async (
  params: ProxyUrlGETParams,
  options?: Parameters<typeof mutator>[1]
): Promise<ProxyUrlGET200> => {
  return mutator<ProxyUrlGET200>(getProxyUrlGETUrl(params), {
    ...options,
    method: "GET"
  });
};

export const getProxyUrlGETQueryKey = (params?: ProxyUrlGETParams) => {
  return [`/dpl-url-proxy`, ...(params ? [params] : [])] as const;
};

export const getProxyUrlGETQueryOptions = <
  TData = Awaited<ReturnType<typeof proxyUrlGET>>,
  TError = ErrorType<void>
>(
  params: ProxyUrlGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof proxyUrlGET>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProxyUrlGETQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof proxyUrlGET>>> = ({
    signal
  }) => proxyUrlGET(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof proxyUrlGET>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ProxyUrlGETQueryResult = NonNullable<
  Awaited<ReturnType<typeof proxyUrlGET>>
>;
export type ProxyUrlGETQueryError = ErrorType<void>;

export function useProxyUrlGET<
  TData = Awaited<ReturnType<typeof proxyUrlGET>>,
  TError = ErrorType<void>
>(
  params: ProxyUrlGETParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof proxyUrlGET>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proxyUrlGET>>,
          TError,
          Awaited<ReturnType<typeof proxyUrlGET>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useProxyUrlGET<
  TData = Awaited<ReturnType<typeof proxyUrlGET>>,
  TError = ErrorType<void>
>(
  params: ProxyUrlGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof proxyUrlGET>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proxyUrlGET>>,
          TError,
          Awaited<ReturnType<typeof proxyUrlGET>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useProxyUrlGET<
  TData = Awaited<ReturnType<typeof proxyUrlGET>>,
  TError = ErrorType<void>
>(
  params: ProxyUrlGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof proxyUrlGET>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Generate proxy url
 */

export function useProxyUrlGET<
  TData = Awaited<ReturnType<typeof proxyUrlGET>>,
  TError = ErrorType<void>
>(
  params: ProxyUrlGETParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof proxyUrlGET>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getProxyUrlGETQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
